import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators'

@Injectable({providedIn: 'root'})
export class MensagemProvider {

  baseUrl = environment.API_URL;

  counterMsgNaoLida = 0;

  constructor(public http: HttpClient) { }

  getMensagens(filtro: { q: string | number | boolean; }, pag: { currentPage: string | number | boolean; }) {
    let params = new HttpParams()
      .set("expand", "mensagemBasic, entidade")
      .set("page", pag.currentPage)
      .set("per-page", "20")
      .set("q", filtro.q);

    return this.http.get<any>(this.baseUrl + '/mensagem', { observe: 'response', params: params })
      .pipe(map(data => {
        const countHeader = data.headers.get('X-Count-Msg-Nao-Lida');
        this.counterMsgNaoLida = countHeader !== null ? parseInt(countHeader) : 0;

        let pag = {
          currentPage: data.headers.get("X-Pagination-Current-Page"),
          pageCount: data.headers.get("X-Pagination-Page-Count"),
          perPage: data.headers.get("X-Pagination-Per-Page"),
          totalCount: data.headers.get("X-Pagination-Total-Count"),
        };
        return {
          mensagens: data.body,
          pagination: pag,
          //naoLidas: data.headers.get('X-Count-Msg-Nao-Lida')
        };
      }));
  }

  getMensagem(id: string) {
    let params = new HttpParams()
      .set("expand", "links,criador,perguntas,respondida,exibirResultado");

    return this.http.get<any>(this.baseUrl + '/mensagem/' + id, { observe: 'response', params: params })
      .pipe(map(data => {
        const countHeader = data.headers.get('X-Count-Msg-Nao-Lida');
        this.counterMsgNaoLida = countHeader !== null ? parseInt(countHeader) : 0;

        return {
          mensagem: data.body,
          //naoLidas: data.headers.get('X-Count-Msg-Nao-Lida')
        };
      }));
  }

  getInicioMensagens() {
    return this.http.get<any>(this.baseUrl + '/mensagem/nao-lidas')
      .pipe(map(data => {
        if (!data.error) {
          this.counterMsgNaoLida = data;
          return data;
        } else {
          return false;
        }
      }));
  }


  getTotalMensagensNaoLidas() {
    return this.counterMsgNaoLida;
  }

  excluir(idsList: any[]) {
    return this.http.post<any>(this.baseUrl + '/mensagem/excluir', { ids: idsList }, { observe: 'response' })
      .pipe(map(data => {
        const countHeader = data.headers.get('X-Count-Msg-Nao-Lida');
        this.counterMsgNaoLida = countHeader !== null ? parseInt(countHeader) : 0;
        return {
          status: data.body,
        };
      }));
  }

  excluirCaixa() {
    return this.http.post<any>(this.baseUrl + '/mensagem/excluir-caixa', {}, { observe: 'response' })
      .pipe(map(data => {
        const countHeader = data.headers.get('X-Count-Msg-Nao-Lida');
        this.counterMsgNaoLida = countHeader !== null ? parseInt(countHeader) : 0;
        return {
          status: data.body,
        };
      }));
  }


  criarMensagem(mensagem: any) {
    return this.http.post<any>(this.baseUrl + '/mensagem', mensagem)
      .pipe(map(data => {
        if (!data.error) {
          return data;
        } else {
          return false;
        }
      }));
  }

}
